// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_p2P","cls2":"SimplePaperPodcast-cls2_WRI SimplePaperPodcast-cls1_p2P"};